import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function ModalAbout() {
  useEffect(() => {
    document.title = "Flipcard - About";
    return () => {
      document.title = "Flipcard";
    };
  }, []);
  return (
    <div className="about">
      <h2 className="darktextColor textNavbarBrand">About</h2>
      <div className="about-box">
        <p className="darktextColor text">
          Founded on February 17, 2021, Flipcard was created to be a place where
          you can put the collected account links into one link, making it easy
          to use
        </p>
        <p className="darktextColor text">
          You only need to specify one unique username to make your flipcard
          link easy to remember. Then start adding links to your accounts into
          it.
        </p>
        <p className="darktextColor text">
          Imagine that you only need to share one flipcard link that contains
          all your account link information. with just one copy and use it
          anywhere anytime.
        </p>
        <p className="darktextColor text">
          Flipcard helps you to manage all your account links
        </p>
        <p className="darktextColor textSmall ">
          <Link to="/" className="link-back darktextColor">
            &larr; back
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ModalAbout;
